import React, { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";

import SelectItem from "../../app/generic/selectItem";
import { loadDocumentTypes } from "../../../modules/staticDataLoad";
import SelectItemWithLoad from "../../app/generic/selectItemWithLoad";

export default function DocumentTypes({ getFieldDecorator, formItemLayout }) {
  const intl = useIntl();

  const [documentTypes, setDocumentTypes] = useState();
  const handleDocTypeLoad = useCallback(() => {
    loadDocumentTypes((data) =>
      setDocumentTypes(
        data && data !== "e"
          ? data.map((t) => ({
              id: t,
              name: intl.formatMessage({
                id: `document.${t}`,
                defaultMessage: t,
              }),
            }))
          : data
      )
    );
  }, [intl]);
  useEffect(() => {
    handleDocTypeLoad();
  }, [handleDocTypeLoad]);

  return (
    <SelectItemWithLoad
      skeleton
      options={documentTypes}
      onClick={handleDocTypeLoad}
      errorMessage={intl.formatMessage({
        id: "document.type.error",
        defaultMessage: "Při načítání typů dokumentu nastala chyba",
      })}
    >
      <SelectItem
        allowClear
        label={intl.formatMessage({
          id: "document.type",
          defaultMessage: "Typ dokumentu",
        })}
        options={documentTypes}
        fieldName="documentType"
        formItemLayout={formItemLayout}
        message={intl.formatMessage({
          id: "document.type.miss",
          defaultMessage: "Vyberte prosím typ dokumentu",
        })}
        getFieldDecorator={getFieldDecorator}
      />
    </SelectItemWithLoad>
  );
}
